/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type RenameWorkspaceInput = {
    workspaceId: string;
    name: string;
    clientMutationId?: string | null | undefined;
};
export type renameWorkspaceModalRenameWorkspaceMutationVariables = {
    input: RenameWorkspaceInput;
};
export type renameWorkspaceModalRenameWorkspaceMutationResponse = {
    readonly renameWorkspace: {
        readonly workspace: {
            readonly id: string;
        };
    } | null;
};
export type renameWorkspaceModalRenameWorkspaceMutation = {
    readonly response: renameWorkspaceModalRenameWorkspaceMutationResponse;
    readonly variables: renameWorkspaceModalRenameWorkspaceMutationVariables;
};



/*
mutation renameWorkspaceModalRenameWorkspaceMutation(
  $input: RenameWorkspaceInput!
) {
  renameWorkspace(input: $input) {
    workspace {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RenameWorkspacePayload",
    "kind": "LinkedField",
    "name": "renameWorkspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "renameWorkspaceModalRenameWorkspaceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "renameWorkspaceModalRenameWorkspaceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "66aa15ee7b148c0cd769f1e49c2140b9",
    "id": null,
    "metadata": {},
    "name": "renameWorkspaceModalRenameWorkspaceMutation",
    "operationKind": "mutation",
    "text": "mutation renameWorkspaceModalRenameWorkspaceMutation(\n  $input: RenameWorkspaceInput!\n) {\n  renameWorkspace(input: $input) {\n    workspace {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b0666281c6ea74ebd0310a928d73fc14';
export default node;
